import { Signal } from "@angular/core";
import { StoreAnimalWeighing } from "./model/registrations/store-animal-weighing";
import { updateAllObjectsInMap } from "../../functions/store-update-map.function";

export const updateAnimalWeighings = (
  newItems: Partial<StoreAnimalWeighing>[],
  dataFromStore: Signal<Record<string, StoreAnimalWeighing>>

) => {
  const updatedMap = updateAllObjectsInMap(newItems, dataFromStore);
  const newState = {
    animalWeghings: updatedMap as Record<string, StoreAnimalWeighing>,
  };
  return newState;
};
